import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const ArrowDrawIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="216" height="46" viewBox="0 0 216 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M196.794 10.71C201.998 13.2195 208.661 15.454 213.265 19.1372C213.575 19.3854 214.263 19.95 214.372 20.329C215.023 22.6103 210.722 25.2187 209.213 26.6564C206.897 28.8635 202.998 32.7218 201.714 35.29M1.56152 19.1372C29.6107 19.1372 177.409 25.3181 204.455 21.4359"
      stroke={props.color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)
